import React, { Component } from 'react';
import { Spin,Modal } from 'antd';
import { Switch, Route, Redirect } from 'react-router-dom';
import MyFrame from '../components/Frame';
import '../css/mall.css';
import MStandard from "./mall/MStandard";
import MWorkCard from "./mall/MWorkCard";
import underscore from "underscore";
import { app, api,config } from "../app";

class Mall extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu_key: '0',
            classList: [],
            menuList: [],
            class_info: {},
            loading: true,
        };
    }

    componentDidMount() {
        // 去掉token，不用token也可获取数据
        // if (app.getToken()) {
        //     const _this = this;
        //     console.log("111");
        //     this.ClassList().then((data) => {
        //         console.log("222");
        //         const menuList = underscore.map(data, (cla, i) => {
        //             return ({key: i + '', text: cla.class_name});
        //         });
        //         console.log("333");
        //         _this.setState({menuList, classList: data, class_info: data[0], loading: false});
        //     });
        //     console.log("444");
        // }
        const _this = this;
        this.ClassList().then((data) => {
            const menuList = underscore.map(data, (cla, i) => {
                return ({ key: i + '', text: cla.class_name });
            });
            _this.setState({ menuList, classList: data, class_info: data[0], loading: false });
        });


       


    }

    torealize = (mall_id) =>{
        this.insureModal.destroy()
        this.props.history.push(`/mall/detail/${mall_id}`)
    }

    handleMenuClick = (key) => {
        config.mall_isDo2 = false;
        const path = this.props.location.pathname;
        if (path.indexOf('/mall/detail/') > -1) this.props.history.push(`/mall`);
        const classList = this.state.classList,
            class_info = classList[parseInt(key)];
        this.setState({ class_info, menu_key: key });
    }

    componentWillReceiveProps(props) {
        // console.log(props);
    }

    /**
     * 分类集合
     * @returns {Promise<any>}
     * @constructor
     */
    ClassList = () => {
        return new Promise((resolve, reject) => {
            const params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                type: 0,
            };
            app.post(api.MallClassListing, params).then(({ flag, data, msg }) => {
                // console.log(data);
                if (flag === 1) {
                    resolve(data);
                } else {
                    app.alert(msg, 'warn');
                    reject();
                }
            })
        })
    }

    render() {
        const { menu_key, class_info, menuList, loading } = this.state, isLogin = app.checkLogin();
        // 2022-06-13 不登陆也可查看商城 cwj
        // if (isLogin) {
        //     // return (<Redirect to="/"/>)
        // } else {
        //     return (
        //         <MyFrame className="mall" history={this.props.history} menuList={menuList}
        //                  menuSelectKey={menu_key}
        //                  menuClick={(key) => this.handleMenuClick(key)}>
        //             {loading ?
        //                 (<div className="mall-loading"><Spin size="large"/></div>) :
        //                 (
        //                     <Switch>
        //                         <Route key={1} exact path="/mall" render={(props) => {
        //                             props.class_info = class_info;
        //                             return (<MStandard {...props}/>);
        //                         }}/>
        //                         <Route key={2} exact path="/mall/detail/:id" component={MWorkCard}/>
        //                         <Route render={() => <Redirect to="/mall"/>}/>
        //                     </Switch>
        //                 )
        //             }
        //             {/*<Route exact path="/mall/work-card" component={MWorkCard}/>*/}
        //             {/*<Route render={() => <Redirect to="/mall/standard"/>}/>*/}
        //         </MyFrame>
        //     );
        // }
        return (
            <MyFrame className="mall" history={this.props.history} menuList={menuList}
                menuSelectKey={menu_key}
                menuClick={(key) => this.handleMenuClick(key)}>
                {loading ?
                    (<div className="mall-loading"><Spin size="large" /></div>) :
                    (
                        <Switch>
                            <Route key={1} exact path="/mall" render={(props) => {
                                props.class_info = class_info;
                                return (<MStandard {...props} />);
                            }} />
                            <Route key={2} exact path="/mall/detail/:id" component={MWorkCard} />
                            <Route render={() => <Redirect to="/mall" />} />
                        </Switch>
                    )
                }
                {/*<Route exact path="/mall/work-card" component={MWorkCard}/>*/}
                {/*<Route render={() => <Redirect to="/mall/standard"/>}/>*/}
            </MyFrame>
        );
    }
}

export default Mall;



// WEBPACK FOOTER //
// ./src/routes/Mall.jsx